<template>
  <v-app>
    <AllowedUserContainer :page-type="'writer'">
      <SessionShareContainer />
      <WriterHeader />
      <div class="d-flex">
        <WriterSidebarContainer />
        <div class='d-block' style='width: 100%; margin-top: 50px'>
          <DataLoader
            v-if="generalItemsLoading"
            :loading="generalItemsLoading"
          />
          <router-view v-else />
          <slot />
        </div>
      </div>
    </AllowedUserContainer>
    <toaster />
    <loading-overlay />
    <SystemInformationConfirmDialog></SystemInformationConfirmDialog>
  </v-app>
</template>

<script>
import Toaster from '@/components/commons/Toaster'
import LoadingOverlay from '@/components/commons/LoadingOverlay'
import LogoutBtn from '@/components/commons/LogoutBtn'
import DataLoader from '@/components/commons/DataLoader'
import { mapState } from 'vuex'
import AllowedUserContainer from '../../src/container/shared/AllowedUserContainer'
import SessionShareContainer from '../../src/container/shared/SessionShare'
import SystemInformationConfirmDialog from '../../src/container/shared/SystemInformationDetailDialogs/confirm.vue'
import WriterHeader from '../../src/components/shared/WriterHeader'
import WriterSidebarContainer from '../../src/container/shared/WriterSidebarContainer'

export default {
  name: 'App',
  components: {
    WriterSidebarContainer,
    WriterHeader,
    SessionShareContainer,
    AllowedUserContainer,
    Toaster,
    LoadingOverlay,
    LogoutBtn,
    DataLoader,
    SystemInformationConfirmDialog
  },
  data: () => ({
    generalItemsLoading: true,
    dialog: false,
    drawer: null,
    accountMenu: false,
    sideBarItems: [
      {
        icon: 'mdi-monitor-dashboard',
        text: 'ダッシュボード',
        router: { name: 'writerDashboard' }
      },
      { icon: 'mdi-pencil', text: '執筆', router: { name: 'writerPosts' } },
      {
        icon: 'mdi-clipboard-text-multiple',
        text: '募集記事',
        router: { name: 'writerOrderBoard' }
      }
    ]
  }),
  computed: {
    ...mapState({
      site: (state) => state.SiteStore.site,
      currentUser: (state) => state.UserStore.currentUser
    }),
    logoUrl: function () {
      if (this.site.logo) {
        return this.site.logo.url
      } else {
        return null
      }
    }
  },
  mounted: function () {
    this.$store.subscribe((mutation) => {
      if (mutation.type === 'SiteStore/setSite') {
        this.generalItemsLoading = false
      }
    })
  }
}
</script>

<style scoped>
.accountMenu {
  z-index: 999;
}
</style>
